import type { SearchNewsQueryVariables } from '#lib/websites/news/mutations/__generated__/searchNews.generated.js';

// `searchNews` is a relevance resolver, not a Directus filter query, so it
// requires a non-empty `searchPhrase` — return undefined for empty input so
// QuerySearch short-circuits to the empty response instead of firing a request.
export const getVariables = (
	value: string
): SearchNewsQueryVariables | undefined => {
	if (!value) {
		return undefined;
	}

	return {
		searchPhrase: value,
		limit: 5,
	};
};
